import { useState } from "react";

const fnameValidator = (fname: string) => {
  if (!fname) {
    return "*All fields are required";
  }
  return "";
};

const lnameValidator = (lname: string) => {
  if (!lname) {
    return "*All fields are required";
  }
  return "";
};

const emailValidator = (email: string) => {
  if (!email) {
    return "*All fields are required";
  } else if (!new RegExp(/\S+@\S+\.\S+/).test(email)) {
    return "Incorrect email format";
  }
  return "";
};

const touchErrors = (errors: any) => {
  return Object.entries(errors).reduce((acc: any, [field, fieldError]: any) => {
    acc[field] = {
      ...fieldError,
      dirty: true,
    };
    return acc;
  }, {});
};

export const useUserDetailsFormValidator = (form: any) => {
  const [errors, setErrors] = useState<any>({
    fname: {
      dirty: false,
      error: false,
      message: "",
    },
    lname: {
      dirty: false,
      error: false,
      message: "",
    },
    email: {
      dirty: false,
      error: false,
      message: "",
    },
  });

  const validateForm = ({ form, field, errors, forceTouchErrors = false }: any) => {
    let isValid = true;

    // Create a deep copy of the errors
    let nextErrors = JSON.parse(JSON.stringify(errors));

    // Force validate all the fields
    if (forceTouchErrors) {
      nextErrors = touchErrors(errors);
    }

    const { fname, lname, email } = form;

    if (nextErrors.fname.dirty && (field ? field === "fname" : true)) {
      const fNameMessage = fnameValidator(fname);
      nextErrors.fname.error = !!fNameMessage;
      nextErrors.fname.message = fNameMessage;
      if (!!fNameMessage) isValid = false;
    }

    if (nextErrors.lname.dirty && (field ? field === "lname" : true)) {
      const lNameMessage = lnameValidator(lname);
      nextErrors.lname.error = !!lNameMessage;
      nextErrors.lname.message = lNameMessage;
      if (!!lNameMessage) isValid = false;
    }

    if (nextErrors.email.dirty && (field ? field === "email" : true)) {
      const emailMessage = emailValidator(email);
      nextErrors.email.error = !!emailMessage;
      nextErrors.email.message = emailMessage;
      if (!!emailMessage) isValid = false;
    }

    setErrors(nextErrors);

    return {
      isValid,
      errors: nextErrors,
    };
  };

  const onBlurField = (e: any) => {
    const field = e.target.name;
    const fieldError = errors[field];
    if (fieldError.dirty) return;

    const updatedErrors = {
      ...errors,
      [field]: {
        ...errors[field],
        dirty: true,
      },
    };

    validateForm({ form, field, errors: updatedErrors });
  };

  return {
    validateForm,
    onBlurField,
    errors,
  };
};
